module.exports = __webpack_public_path__ + "static/media/signage-indoor-img71.3d3a26c9.jpg";